import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { azureAllAccountsSelector } from "./azureAllAccountsSelector";
import { accountsSortBySelector } from "../slice-data/accountsSortBySelector";
import { accountsSortingCombiner } from "../../combiners/accountsSortingCombiner";

export const azureSortedAccountsSelector = createDraftSafeSelector(
  [azureAllAccountsSelector, accountsSortBySelector],
  accountsSortingCombiner,
);
